import { getOrgById } from '@/api/org'
import { getOrgEmployees } from '@/api/employee'

const state = () => ({
  isLoading: false,
  error: null,
})

const mutations = {
  setLoading(state, loading) {
    state.isLoading = loading
  },

  setError(state, error) {
    state.error = error
  },
}

function patchFirstEmployee(employees, fullEmployee, org) {
  return (employees || []).map((employee, index) => {
    if (index !== 0) return employee

    return {
      ...employee,
      ...fullEmployee,
      departments: fullEmployee?.departments || [],
      org,
    }
  })
}

const actions = {
  async fetchOnboardingData({ commit, rootState }, orgId) {
    commit('setLoading', true)
    commit('setError', null)

    try {
      const [orgResponse, employeesResponse] = await Promise.all([
        getOrgById(orgId),
        getOrgEmployees(orgId),
      ])

      const org = orgResponse?.data
      const employee = employeesResponse?.data?.[0]
      const user = rootState.auth?.user

      if (user?.employees?.length) {
        commit(
          'auth/setUser',
          {
            ...user,
            employees: patchFirstEmployee(user.employees, employee, org),
            roles: user?.roles || [],
          },
          { root: true }
        )
      }

      return { employee, org }
    } catch (error) {
      commit('setError', 'Ошибка загрузки данных онбординга')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
}

const getters = {
  isOnboardingCompleted(state, getters, rootState) {
    const employee = rootState.auth?.user?.employees?.[0]
    if (!employee) return false

    return Boolean(
      employee.departments?.length && employee.org?.business_subtypes?.length
    )
  },

  isLoading(state) {
    return state.isLoading
  },

  getError(state) {
    return state.error
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
